import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ShopProvider } from './contexts/aniplus';
import HttpsRedirect from 'react-https-redirect';

import App from './App';
import './css/style.css';
import './css/style_v2.css';
import './css/chat.css';
import './css/progress.css';
import './css/mypage.css';
import './css/cashcard.css';
import './css/event.css';
import './css/set.css';
import './css/friendadd.css';
import './css/live.css';
import './css/time_tbl.css';
import './css/vod.css';
import './css/style_m.css';

import './css/theme_lt.css';
import './css/store.css';

import 'react-responsive-modal/styles.css';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-confirm-alert/src/react-confirm-alert.css';

import 'react-quill/dist/quill.snow.css';

import './imgmap.js';
import { HelmetProvider } from 'react-helmet-async';

//import { QueryClientProvider, QueryClient } from 'react-query'
//const queryClient = new QueryClient();

const Root = () => (
  <ShopProvider>
    <BrowserRouter>
      <HttpsRedirect>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </HttpsRedirect>
    </BrowserRouter>
  </ShopProvider>
);

export default Root;
